import styled from 'styled-components/macro'

export const Title = styled.h1`
  margin: 0;
  padding: 1.2rem 3.2rem;
  height: 4.6rem;
  font-size: 1.8rem;
  line-height: 1;
  letter-spacing: -0.018rem;
  text-align: center;
  border-bottom: 0.1rem solid ${(props) => props.theme.color.elementBorder};
`

export const Article = styled.article`
  margin: 0 auto;
  padding: 3.2rem 1.6rem;
  width: 100%;
  max-width: 70rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`

export const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${(props) => props.theme.color.pageBg};
  overflow: hidden;
`

export const Wrap = styled.div`
  position: relative;
  padding: 6rem 1.6rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    padding: 12rem 3.2rem;
  `};
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    padding: 16rem 4.8rem;
  `};
`

export const Container = styled.div`
  width: 100%;
  max-width: 124rem;
  display: grid;
  grid-template-columns: 1fr;
  gap: 3.2rem;
  z-index: ${(props) => props.theme.zIndex.minimal};
  ${(props) => props.theme.breakpoints.greaterThan('md')`
    grid-template-columns: .75fr 1.5fr;
    justify-content: space-between;
    gap: 6.2rem;
  `};
`

export const Items = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
`

export const Content = styled.p`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.4;
  text-align: left;
`
